export default {
      id: "app-volume-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#app-volume",
      toString: function () {
        return this.url;
      }
    }